import React from "react";
import "./WeekView.scss";

import DayEvents from "./DayEvents";

import { splitEventsIntoDays } from "~/tools/date-utils";

const WeekView = ({ data }) => {
  const daysEvents = splitEventsIntoDays(data);
  return (
    <div className="WeekView">
      {daysEvents.map((e, i) => (
        <DayEvents key={i} eventsByDay={e} />
      ))}
    </div>
  );
};

export default WeekView;
